<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="门店列表" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <mt-button slot="right"  @click="goAdd">新增</mt-button>
            </mt-header>
        </div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <ul class="chain"  v-if="chain_list && chain_list.length">
                <li v-for="item in chain_list" :key="item.chain_id" @click="onEdit(item.chain_id)">
                    <em>{{item.chain_addressname}}</em>
                    <i class="iconfont">&#xe650;</i>
                </li>
            </ul>
            <empty-record v-else-if="chain_list && !chain_list.length"></empty-record>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import EmptyRecord from '../..//EmptyRecord'
import { getChainList } from '../../../api/sellerChain'
export default {
  name: 'Chain',
  components: {
    EmptyRecord
  },
  data () {
    return {
      // 配送员列表
      chain_list: false,
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  created: function () {
  },
  methods: {
    goAdd () {
      this.$router.push({ name: 'SellerChainForm', query: { action: 'add' } })
    },
    onEdit (chain_id) {
      this.$router.push({ name: 'SellerChainForm', query: { chain_id: chain_id } })
    },
    getChainList (ispush) {
      Indicator.open()
      getChainList({}, this.params).then(res => {
        if (ispush && this.chain_list) {
          this.chain_list = this.chain_list.concat(res.result.chain_list)
        } else {
          this.chain_list = res.result.chain_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        this.loading = false
        Indicator.close()
      }).catch(function (error) {
        this.loading = false
        Toast(error.message)
        Indicator.close()
      })
    },
    loadMore () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.getChainList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.loading = false
      this.chain_list = []
      this.loadMore()
    }
  }
}
</script>

<style scoped>
.chain{}
.chain li{line-height:1rem;padding:.5rem 1rem;background:#fff;font-size:.7rem}
.chain i{float:right}
</style>
